import {
  UPDATE_STEPS,
  QUESTION_ANSWERED,
  EDIT_STEPS, ADD_STEPS,
  CONFIRM_STEPS,
} from '../actions/actionCreators';

export const initialState = {
  stepsId: '',
  steps: null,
  length: null,
  width: 3,
  roolWidth: 12,
  stairsSquareFeet: 0,
  price: 0,
  stairsSquarePrice: 0,
  stairesSFtPrice: 0,
  isEdit: false,
  isAdd: false,
  isConfirmed: false,
  padPrice: null,
  stairsPadPrice: 0,
  totalPrice: 0,
  questionAnswered: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
  case UPDATE_STEPS:
    return {
      ...state,
      stepsId: action.payload.stepsId,
      steps: action.payload.steps,
      length: action.payload.steps * 2,
      stairsSquareFeet: action.payload.stairsSquareFeet,
      price: action.payload.price,
      stairsSquarePrice: action.payload.stairsSquarePrice,
    };
  case 'UPDATE_STEP_PRICE':
    return {
      ...state,
      price: action.payload,
      stairsSquarePrice: parseFloat(((state.stairsSquareFeet / 9) * action.payload).toFixed(2), 2),
    };
  case 'UPDATE_STEP_PAD_PRICE':
    return {
      ...state,
      padPrice: action.payload,
      stairsPadPrice: parseFloat((state.stairsSquareFeet * action.payload).toFixed(2)),
      totalPrice: parseFloat(((state.stairsSquareFeet * action.payload)
          + parseFloat(state.stairsSquarePrice)).toFixed(2), 2),
    };
  case EDIT_STEPS:
    return { ...state, isEdit: action.payload };
  case ADD_STEPS:
    return { ...state, isAdd: action.payload };
  case CONFIRM_STEPS:
    return { ...state, isConfirmed: action.payload };
  case QUESTION_ANSWERED:
    return { ...state, questionAnswered: action.payload };
  default:
    return state;
  }
};
